/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Flow
 */
export interface Flow {
  /**
   * Campaign.id this Flow is assigned to, root or nested
   * @type {string | null}
   * @memberof Flow
   */
  campaignId?: string | null;
  /**
   *
   * @type {number}
   * @memberof Flow
   */
  companyId: number;
  /**
   *
   * @type {number}
   * @memberof Flow
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof Flow
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Flow
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Flow
   */
  dateModifiedIso?: string;
  /**
   * unique id for the Flow - the same as campaign_id when it is the root flow
   * @type {string}
   * @memberof Flow
   */
  flowId?: string;
  /**
   *
   * @type {string}
   * @memberof Flow
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Flow
   */
  key: string;
  /**
   * name of the flow for browsing later potentially
   * @type {string | null}
   * @memberof Flow
   */
  name?: string | null;
  /**
   * list of Rule.id strings for this linear flow
   * @type {Array<any>}
   * @memberof Flow
   */
  rules?: Array<any>;
  /**
   *
   * @type {Array<any>}
   * @memberof Flow
   */
  tags?: Array<any>;
}

/**
 * Check if a given object implements the Flow interface.
 */
export function instanceOfFlow(value: object): value is Flow {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function FlowFromJSON(json: any): Flow {
  return FlowFromJSONTyped(json, false);
}

export function FlowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Flow {
  if (json == null) {
    return json;
  }
  return {
    campaignId: json['campaign_id'] == null ? undefined : json['campaign_id'],
    companyId: json['company_id'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    flowId: json['flow_id'] == null ? undefined : json['flow_id'],
    id: json['id'],
    key: json['key'],
    name: json['name'] == null ? undefined : json['name'],
    rules: json['rules'] == null ? undefined : json['rules'],
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function FlowToJSON(value?: Flow | null): any {
  if (value == null) {
    return value;
  }
  return {
    campaign_id: value['campaignId'],
    company_id: value['companyId'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    flow_id: value['flowId'],
    id: value['id'],
    key: value['key'],
    name: value['name'],
    rules: value['rules'],
    tags: value['tags'],
  };
}
